module.exports = __webpack_public_path__ + "img/biogen.f3514a4f.png";